import shallow from 'zustand/shallow';
import { useAuth } from '@/logic/state';

// This custom hook is used to get user wallet data

export const useUserBalance = () => {
  const user = useAuth(s => s.user, shallow);

  return {
    userFormattedBalance: user?.totalDetailedBalance?.toFixed?.(2) ?? (0).toFixed(2),
    userFormattedWalletBalance:
      user?.walletDetailedBalance?.toFixed?.(2) ?? (0).toFixed(2),
    userFormattedCashbackBalance:
      user?.cashbackDetailedBalance?.toFixed?.(2) ?? (0).toFixed(2),
    userNextExpiredWalletTransaction: user?.walletTransaction,
    userNextExpiredCashbackTransaction: user?.cashbackTransaction,
  };
};
